import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';

type AccordionProps = {
    className?: string;
    // Optional column-label row shown above the items; aligned with each item header.
    headerRow?: React.ReactNode;
    children: React.ReactNode;
};

const Accordion = ({ className, headerRow, children }: AccordionProps): JSX.Element => (
    <div className={`v2-accordion${className ? ` ${className}` : ''}`}>
        {headerRow != null ? (
            <div className="v2-accordion-head-row">
                <div className="v2-accordion-head-content">{headerRow}</div>
                <span
                    className="v2-accordion-head-spacer"
                    aria-hidden="true"
                />
            </div>
        ) : null}
        {children}
    </div>
);

type AccordionItemProps = {
    open: boolean;
    onToggle: () => void;
    header: React.ReactNode;
    expandable?: boolean;
    className?: string;
    children?: React.ReactNode;
};

export const AccordionItem = ({
    open,
    onToggle,
    header,
    expandable = true,
    className,
    children,
}: AccordionItemProps): JSX.Element => (
    <div
        className={`v2-accordion-item${open ? ' is-open' : ''}${expandable ? '' : ' is-disabled'}${
            className ? ` ${className}` : ''
        }`}
    >
        <button
            type="button"
            className="v2-accordion-head"
            onClick={expandable ? onToggle : undefined}
            disabled={!expandable}
            aria-expanded={expandable ? open : undefined}
        >
            <span className="v2-accordion-head-content">{header}</span>
            <span className="v2-accordion-chevron">
                <FontAwesomeIcon icon={faChevronDown} />
            </span>
        </button>
        {open ? <div className="v2-accordion-body">{children}</div> : null}
    </div>
);

export default Accordion;
